import { BaseList, BaseDetail } from "App/Component/Bases";
import fields from "./fields";
import descriptor from "./descriptor";
import options from "./options";

const title = "Rate Types";
const urlData = "rateTypes";
const bulkName = "type";
const availablePermissions = ['.view_'];

class List extends BaseList {
  constructor(props) {
    super(props)

    this.title = title;
    this.urlData = urlData;
    this.bulkName = bulkName;
    this.availablePermissions = this.availablePermissions;
    this.propsList = {
      descriptor,
      exportImport: options.exportImportOptions,
    }
    this.state = {
      ...this.state,
      currentPermissionSet: this.isSuperuser ? availablePermissions : [],
    }
  }
}

class Detail extends BaseDetail {
  constructor(props) {
    super(props)

    this.title = title;
    this.urlData = urlData;
    this.bulkName = bulkName;
    this.fields = fields;
    this.availablePermissions = availablePermissions;
    this.propsDetail = {
      urlKeyHistory: 'api:admin:jobs:ratetype:detail-revision',
      keyLabel: 'type'
    }
    this.state = {
      ...this.state,
      currentPermissionSet: this.isSuperuser ? availablePermissions : [],
    }
  }
}

export default { List, Detail };